module.exports = __webpack_public_path__ + "static/media/a.16f5e415.jpg";